<template>
  <div>
    <!-- {{ filterFor }} -->
    <div style="height: 150px" class="my-2">
      <v-img
        src="https://www.eyedock.com/images/pathologies/eyeModifiers.svg"
        height="140px"
        contain
        :position="
          $vuetify.breakpoint.smAndUp ? 'start center' : 'center center'
        "
      ></v-img>
    </div>
    <div v-for="(group, num) in modifiersByGroup" :key="num" class="mt-4">
      <div class="text-h6 width100p">
        {{ groupTitles[num - 1] }}
      </div>
      <table class="width100p">
        <tbody>
          <tr>
            <th class="col1"></th>
            <th class="col2">CPT Definition</th>
            <th class="col2" v-if="$vuetify.breakpoint.smAndUp">Hint</th>
          </tr>
          <tr
            v-for="(modifierId, i) in group"
            :key="i"
            :class="
              filterFor.includes(modifiers[modifierId].modifier)
                ? 'highlighted'
                : ''
            "
          >
            <th class="col1">
              {{ modifiers[modifierId].modifier }}
            </th>
            <td class="col2">
              {{ modifiers[modifierId].name }}
              <div
                class="caption blue--text"
                v-if="
                  !$vuetify.breakpoint.smAndUp && modifiers[modifierId].notes
                "
              >
                - {{ modifiers[modifierId].notes }}
              </div>
            </td>
            <td v-if="$vuetify.breakpoint.smAndUp" class="col2">
              {{ modifiers[modifierId].notes }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="my-6">&nbsp;</div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "BillingModifiers",
  props: {
    modifiers: null,
    modifiersByGroup: null,
    filterFor: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      groupTitles: [
        "Eye Modifiers",
        "Common Modifiers",
        "Less Common Modifiers",
      ],
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
th {
  background-color: #ceeaff;
}
th,
td {
  padding: 2px 8px;
  border: 1px solid #7b9fba;
  vertical-align: top;
}

table {
  border-collapse: collapse;
}
.tableWidth {
  min-width: 300px;
}
tr:nth-child(odd) {
  background-color: #f8fcff;
}
.highlighted {
  font-weight: bold;
}
.highlighted td {
  background-color: #ffffbe !important;
}
.col1 {
  width: 50px;
}
.col2 {
  width: 50%;
}
</style>
